import { render, staticRenderFns } from "./IndexBottom.vue?vue&type=template&id=2c7a5221&scoped=true"
import script from "./IndexBottom.vue?vue&type=script&lang=js"
export * from "./IndexBottom.vue?vue&type=script&lang=js"
import style0 from "./IndexBottom.vue?vue&type=style&index=0&id=2c7a5221&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a5221",
  null
  
)

export default component.exports